import { render, staticRenderFns } from "./SaleIndex.vue?vue&type=template&id=6de24554"
import script from "./SaleIndex.vue?vue&type=script&lang=js"
export * from "./SaleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports